import React from 'react';
import Reveal from '../../../shared/Reveal/Reveal';
import { useWealthSavingsApproachContent } from '../../../../hooks/useWealthSavingsApproachContent';
import './Approach.css';

const Approach = () => {
  const { content, isLoading } = useWealthSavingsApproachContent();

  if (isLoading || !content) {
    return null;
  }

  const { title, paragraphs, image } = content;

  return (
    <section className="wealth-approach">
      <div className="wealth-approach__inner">
        <Reveal className="wealth-approach__copy">
          <h2 className="wealth-approach__title">{title}</h2>
          {paragraphs.map((paragraph) => (
            <p key={paragraph} className="wealth-approach__text">
              {paragraph}
            </p>
          ))}
        </Reveal>

        {image ? (
          <Reveal className="wealth-approach__media" delay={80}>
            <img
              className="wealth-approach__image"
              src={image}
              alt=""
              aria-hidden="true"
            />
          </Reveal>
        ) : null}
      </div>
    </section>
  );
};

export default Approach;
